import { syncWindowDefinitions } from '../../../lib/syncWindowDefinitions';

const getBannersUrl      = '/staff_banners';
const dismissBannersUrl = '/staff_banners/dismiss';

class DashboardScreenController {
  constructor(
    $scope,
    $rootScope,
    $q,
    $sce,
    $timeout,
    $interval,
    $translate,
    $anchorScroll,
    APIService,
    DataSyncService,
    LogService,
    ThemeSwitcherService,
    DashboardNotificationService,
    adhocModal,
    filesModal,
    addPhotosModal,
    guerrillaModal,
    editPositionModal,
    PayrollPeriodService,
    PositionSearchService,
    showPositionSearchModal,
    showNetworkSettingsModal,
    showChangePasswordModal,
    StaffUserService,
    $log
  ) {
    "ngInject";
    this.$scope               = $scope;
    this.$rootScope           = $rootScope;
    this.APIService           = APIService;
    this.DataSyncService      = DataSyncService;
    this.LogService           = LogService;
    this.ThemeSwitcherService = ThemeSwitcherService;
    this.DashboardNotificationService = DashboardNotificationService;
    this.$q                   = $q;
    this.$sce                 = $sce;
    this.$timeout             = $timeout;
    this.$interval            = $interval;
    this.$translate = $translate;
    this.$anchorScroll = $anchorScroll;
    this.adhocModal           = adhocModal;
    this.filesModal           = filesModal;
    this.addPhotosModal       = addPhotosModal;
    this.guerrillaModal       = guerrillaModal;
    this.editPositionModal    = editPositionModal;
    this.PayrollPeriodService = PayrollPeriodService;
    this.PositionSearchService = PositionSearchService;
    this.showPositionSearchModal = showPositionSearchModal;
    this.showNetworkSettingsModal = showNetworkSettingsModal;
    this.showChangePasswordModal = showChangePasswordModal;
    this.StaffUserService     = StaffUserService;
    this.$log                 = $log;

    this._errors                        = [];
    this._loading                       = false;
    this._declinedClaims                = 0;
    this._numPreviousPositionsToDisplay = 10;
    this._numUpcomingPositionsToDisplay = 10;
    this._numCurrentPositionsToDisplay  = 10;

    this._profile = {};

    this.autoRefreshTimerPromise = null;

    // Handle 'sync' event by calling DataSyncService
    this.$rootScope.$on('sync', e => {
      this._cancelAutoRefreshTimer();
      return this.DataSyncService.sync();
    });

    // Update claims when refresh positions has completed
    this.$rootScope.$on('syncComplete', e => {
      // Always update claims after refresh is complete
      this._updateClaimsForStaffUser(this._staffUser);
      this._updateNotifications();
      this._setBanners();
      this._initAutoRefreshTimer();
    });

    this.$scope.$on('showFiles', (e, position) => {
      this.showFiles(position);
    });

    this.$scope.$on('showAddPhotos', (e, position) => {
      this.showAddPhotos(position);
    });

    this.$scope.$on('showAddGuerilla', (e, position) => {
      this.addGuerrilla(position);
    });

    this.$scope.$on('showEditPosition', (e, position) => {
      this.showEditPosition(position);
    });

    /**
     * As of MJOL-586 we are no longer showing this network settings modal.
     * This code can be removed once we're sure they're not going to change their minds.
     */
    this.$scope.$on('showNetworkSettingsModal', (e) => {
      this.openNetworkSettingsModal();
    });


    this.APIService.addOnlineStatusListener(() => this._updateNotifications());

    this._claimsGroupedByPayrollPeriod = null;
    this._claimPayrollPeriodPanelsCollapsed = {};
    this._constructed = true;

    this._notifications = [];

    // Subscribe to LanguageServiceChangedLanguage; when language changes we need to re-translate since we're caching them
    this.$scope.$on('LanguageServiceChangedLanguage', () => {
      this.DashboardNotificationService.clearTranslatedTextForAllNotifications();
      this._updateNotifications();
    });
  }

  $onInit() {
    if (this.staffUser) {
      this._updateClaimsForStaffUser(this.staffUser);
      this._updateNotifications();
      this._setBanners();
      this._initAutoRefreshTimer();
    }
  }

  // Imported by component binding
  set staffUser( staffUser ) {
    this._staffUser = staffUser;
    if (this._constructed) {
      this._updateClaimsForStaffUser(staffUser);
    }
  }
  get staffUser() {
    return this._staffUser;
  }
  get declinedClaims() {
    return this._declinedClaims;
  }

  get profile() {
    return this._profile;
  }

  get claimsGroupedByPayrollPeriod() {
    return this._claimsGroupedByPayrollPeriod;
  }

  get isDashboardCurrentlyFocused()
  {
    return (this.isDashboardVisible === true) && (this.isAnyModalOpen === false);
  }

  get isDashboardVisible() {
    return angular.element('#dashboard-container').is(':visible');
  }

  get isAnyModalOpen() {
    return angular.element('body').hasClass('modal-open');
  }

  get numberRecapsDue() {

    let count = 0;

    if (this.staffUser.currentPositions)
    {
      for(let i=0;i < this.staffUser.currentPositions.length;i++)
      {
        let position = this.staffUser.currentPositions[i];

        if (!position.hasRecap && !position.enqueuedRecapResponse)
        {
          count++;
        }
      }
    }

    if (this.staffUser.previousPositions)
    {
        for(let i=0;i < this.staffUser.previousPositions.length;i++)
        {
            let position = this.staffUser.previousPositions[i];

            if (position.canRecap && !position.hasRecap)
            {
                count++;
            }
        }
    }

    return count;
  }

  get notifications() {
    return this._notifications;
  }

  get banners() {
    return this._banners;
  }

  getFormattedTextForBanner(bannerText) {
    if (bannerText) {
      return this.$sce.trustAsHtml(bannerText);
    } 
  }


  dismissBanner(banner) {
    // set dismissing on banner
    const b = this.banners.find(b => b.id === banner.id)
    if (b.dismissing) {
      return;
    }
    if (b) {
      b.dismissing = true;
    }
    this.APIService.post(dismissBannersUrl, { banner_id: banner.id })
      
  }

  /**
   * Position search button
   */
  get positionSearchEnabled() {
    return true;
  }

  get positionSearchFiltersActive() {
    return this.PositionSearchService && this.PositionSearchService.anyAppliedFiltersActive;
  }

  resetPositionSearch() {
    return this.$timeout(() => {
      this.PositionSearchService && this.PositionSearchService.resetFiltersAndApply();
    });
  }

  get themeName() {
    return this.ThemeSwitcherService.translatedThemeName;
  }

  get oppositeThemeName() {
    return this.ThemeSwitcherService.oppositeThemeName;
  }

  toggleTheme() {
    return this.ThemeSwitcherService.toggleTheme();
  }

  get isDarkThemeActive() {
    return !!this._isDarkThemeActive;
  }

  toggleDarkTheme() {
    this._isDarkThemeActive = !this.isDarkThemeActive;
    if (this.isDarkThemeActive) {
    }
  }

  editProfile() {
    this.$scope.$emit('showEditProfile', this._profile);
  }

  changePassword() {
    return this.showChangePasswordModal()
      .then(result => {
        this.LogService.debug(`DashboardScreenController.changePassword() got result:`, result);
      })
      .catch(err => {
        this.LogService.debug(`DashboardScreenController.changePassword() got error:`, err);
      });
  }

  logout() {
    this.$scope.$emit('logout');
  }

  addAdhoc() {
    this.adhocModal({
      staffUser: this.staffUser
    })
      .then(() => {
      });
  }

  showFiles(position) {
    // Position-specific docs plus the event's own collateral: files on its program,
    // and on the brands and products recorded for this event
    // (see EventSerializer::program_documents, from
    // DocumentRepository::getEventBrandProductFiles).
    const positionDocuments = position.documents || [];
    const programDocuments  = (position.event && position.event.program_documents) || [];
    // A file can be both attached to the position and a program/brand/product
    // doc; dedup by id so it is not listed twice.
    const seen      = {};
    const documents = [].concat(positionDocuments, programDocuments).filter((doc) => {
      const key = doc && doc.id != null ? String(doc.id) : null;
      if (key === null) return true;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
    this.filesModal({
      documents: documents,
    })
      .then(() => {
      });
  }

  showAddPhotos(position) {
    this.addPhotosModal({
      position: position,
    })
      .then(() => {
      });
  }

  addGuerrilla(position) {
    this.guerrillaModal({
      position: position,
      staffUser: this.staffUser,
    })
      .then(() => {
      });
  }

  showEditPosition(position) {
    this.editPositionModal({
      position: position,
      staffUser: this.staffUser,
    })
      .then(() => {
      });
  }

  openPositionSearchModal() {
    return this.showPositionSearchModal({
      staffUser: this.staffUser,
    });
  }

  openNetworkSettingsModal() {
    return this.showNetworkSettingsModal({
      staffUser: this.staffUser,
    });
  }

  /********************************
   * Claims
   ********************************/

  claimPayrollPeriodCollapsed(payrollPeriodsId) {
    let collapsed = true;
    if (payrollPeriodsId in this._claimPayrollPeriodPanelsCollapsed) {
      collapsed = this._claimPayrollPeriodPanelsCollapsed[payrollPeriodsId];
    }
    return collapsed;
  }

  toggleCollapsedForClaimPayrollPeriod(payrollPeriodsId) {
    this._claimPayrollPeriodPanelsCollapsed[payrollPeriodsId] = !this.claimPayrollPeriodCollapsed(payrollPeriodsId);

    // Collapse all others
    Object.keys(this._claimPayrollPeriodPanelsCollapsed).forEach(currId => {
      if (currId !== payrollPeriodsId) {
        this._claimPayrollPeriodPanelsCollapsed[currId] = true;
      }
    });
  }

  expandClaimPayrollPeriod(payrollPeriodsId) {
    this._claimPayrollPeriodPanelsCollapsed[payrollPeriodsId] = false;
  }

  calendarCollapseClicked() {
    this.$timeout(() => {
      this.$scope.$broadcast('DashboardScreen.calendarCollapseChanged');
    });
  }

  /**
   * Initialize the auto-refresh timer, if it has not already been initialized
   * @private
   */
  _initAutoRefreshTimer() {
    const checkAutoRefreshDelay = 10000;
    if (this.autoRefreshTimerPromise) {
      return;
    }

    this.autoRefreshTimerPromise = this.$interval(
      () => this._autoRefreshTimerFired(),
      checkAutoRefreshDelay
    );
  }

  /**
   * Cancels the auto-refresh timer and resets the member variable
   * @private
   */
  _cancelAutoRefreshTimer() {
    if (this.autoRefreshTimerPromise) {
      this.$interval.cancel(this.autoRefreshTimerPromise);
      this.autoRefreshTimerPromise = null;
    }
  }

  /**
   * Check to see if auto-refresh should proceed. All conditions must be met:
   *
   * - Dashboard is visible
   * - Auto-refresh is enabled
   * - Time since last refresh is greater than the auto refresh interval
   * - Sync is not currently in progress
   *
   * If all conditions are met, we cancel our timer, refresh positions, and then re-enable timer
   * @private
   */
  _autoRefreshTimerFired() {
    if (!this.staffUser) {
      this.LogService.warning("DashboardScreenController._autoRefreshTimerFired() called but this.staffUser is not set");
      return false;
    }
    if (this.DataSyncService.isSyncActivityInProgress) {
      this.LogService.debug("DashboardScreenController._autoRefreshTimerFired() called but sync already in progress");
      return false;
    }
    if (!this.isDashboardCurrentlyFocused) {
      this.LogService.debug("DashboardScreenController._autoRefreshTimerFired() called but dashboard is not focused");
      return false;
    }
    let autoRefreshTimeInMinutes = parseInt(this.staffUser.staffing_app_auto_refresh_minutes);
    if (autoRefreshTimeInMinutes <= 0) {
      return false;
    }
    let autoRefreshTimeInMilliseconds = autoRefreshTimeInMinutes * (60 * 1000);
    let timeSinceLastSyncActivity = this.DataSyncService.timeSinceLastSyncActivity;
    if (timeSinceLastSyncActivity >= autoRefreshTimeInMilliseconds) {
      this._cancelAutoRefreshTimer();
      this.DataSyncService.sync()
        .then(() => this._initAutoRefreshTimer());
    }
  }

  _updateClaimsForStaffUser(staffUser) {
    if (staffUser && staffUser.claims) {
      this._claimsGroupedByPayrollPeriod = this.PayrollPeriodService.groupClaimsByPayrollPeriod(staffUser.claims);
      this._declinedClaims = 0;
      for (const claim of staffUser.claims) {
        if (claim.claim_statuses_constant === 'CLAIM_DECLINED') {
          this._declinedClaims++;
        }
      }
    } else {
      this.LogService.warn("No claims set for staff user!", staffUser);
      this._claimsGroupedByPayrollPeriod = [];
      this._declinedClaims = 0;
    }
  }

  _setBanners() {
    this._banners = [];
    if (this.staffUser) {
      if (this.staffUser.banners) {
        this._banners = this.staffUser.banners
      }
    }
  }

  _updateBanners(banners) {
    this._banners = banners;
  }

  _updateNotifications() {
    const promises = [];
    const offlineNotificationId = 'OFFLINE';
    if (!this.APIService.isOnline && this.DataSyncService.numPendingTasks > 0) {
      // Show offline notification when offline AND we have pending tasks
      const offlineNotification = this.DashboardNotificationService.getOrCreateNotificationById(offlineNotificationId);
      offlineNotification.text = `You are <strong>offline</strong>. Your changes will be submitted when you go online.`;
      offlineNotification.translationKey = 'STAFF_APP_NOTIFICATION_OFFLINE';
      offlineNotification.dismissable = false;
    } else {
      // Ensure notification is not shown
      this.DashboardNotificationService.removeNotificationById(offlineNotificationId);
    }

    const declinedClaimsNotificationId = 'DECLINED_CLAIMS';
    const numDeclinedClaims = this.declinedClaims;
    if (numDeclinedClaims > 0) {
      const declinedClaimsNotification = this.DashboardNotificationService.getOrCreateNotificationById(declinedClaimsNotificationId);
      declinedClaimsNotification.text = `You have <a href="javascript:;"><strong>${numDeclinedClaims} declined claims</strong></a> that require attention`;
      declinedClaimsNotification.translationKey = 'STAFF_APP_NOTIFICATION_DECLINED_CLAIMS';
      declinedClaimsNotification.values = { numDeclinedClaims };
      declinedClaimsNotification.dismissable = false;
      declinedClaimsNotification.onClick = () => {
        this.scrollToDeclinedClaims();
      };
    } else {
      this.DashboardNotificationService.removeNotificationById(declinedClaimsNotificationId);
    }

    const recapNotificationId = 'RECAPS_DUE';
    const numRecapsDue = this.numberRecapsDue;
    if (numRecapsDue > 0) {
      const recapNotification = this.DashboardNotificationService.getOrCreateNotificationById(recapNotificationId);
      recapNotification.text = `You have <strong>${numRecapsDue} shifts</strong> that may require recap responses.`;
      recapNotification.values = { numRecapsDue };
      recapNotification.translationKey = 'STAFF_APP_NOTIFICATION_SHIFTS_MAY_REQUIRE_RECAPS';
      recapNotification.dismissable = true;
    } else {
      // Ensure notification is not shown
      this.DashboardNotificationService.removeNotificationById(recapNotificationId);
    }

    /**
     * Sync window notifications
     * These are complicated; we need to do two layers of translations.
     * First we translate the sync window names themselves.
     * Then we pass those translated sync window names as translation values to the notification.
     */
    const currentSyncWindowDefinition = this.DataSyncService.syncWindowDefinition;

    const syncWindowNames = Object.values(syncWindowDefinitions).map(definition => definition.name);
    const syncWindowTranslationKeys = syncWindowNames.map(name=> `SYNC_WINDOW_${name.toUpperCase()}`);
    const syncWindowNotificationId = 'SYNC_WINDOW';
    const syncWindowNotification = this.DashboardNotificationService.getOrCreateNotificationById(syncWindowNotificationId);
    syncWindowNotification.dismissable = true;
    syncWindowNotification.text = `You are showing <strong>${currentSyncWindowDefinition.name}</strong>. (translating...)`;
    syncWindowNotification.translatedText = null;

    const mapToObject = (obj, fn) => Object.keys(obj).reduce((acc, key) => {
      acc[key] = fn(key);
      return acc;
    }, {});

    promises.push(
      this.$translate(syncWindowTranslationKeys)
        .then(translatedSyncWindows => {
          const translatedSyncWindowStrings = mapToObject(translatedSyncWindows, k => translatedSyncWindows[k].toString());
          syncWindowNotification.values = {
            ...translatedSyncWindowStrings,
            currentSyncWindowName: translatedSyncWindowStrings[currentSyncWindowDefinition.translationKey],
          };
          syncWindowNotification.text = `You are showing <strong>${translatedSyncWindows[currentSyncWindowDefinition.translationKey]}</strong>. (translating...)`;
          syncWindowNotification.translationKey = `STAFF_APP_NOTIFICATION_CURRENT_SYNC_WINDOW_${currentSyncWindowDefinition.name.toUpperCase()}`;
        })
    );

    return this.$q.all(promises)
      .then(() => {
        this._notifications = [...this.DashboardNotificationService.notifications];
        // this._notifications = this.DashboardNotificationService.notifications;
      });
  }

  notificationDismissed(notification) {
    this._updateNotifications();
  }

  buildCalendarFeedURL(calendar_id,key){
    return this.APIService.convertAbsolutePathToURLWithHostPrefix('/calendar_feed/feed.php?id='+calendar_id+'&key='+key,'global');
  }

  scrollToDeclinedClaims() {
    const hasDeclinedClaims = payrollPeriodInfo => {
      return payrollPeriodInfo.claims.some(claim => claim.isDeclined);
    };

    const firstDeclinedPeriod = this.claimsGroupedByPayrollPeriod.find(info => hasDeclinedClaims(info));

    if (firstDeclinedPeriod) {
      this.LogService.warn(`DashboardScreenController Scrolling to first declined payroll period:`, firstDeclinedPeriod);

      const payrollPeriodId = firstDeclinedPeriod.payrollPeriodsId;

      // First, ensure the panel is not collapsed
      this.expandClaimPayrollPeriod(payrollPeriodId);

      // Then, scroll to anchor
      const anchor = `claim_payroll_period_${payrollPeriodId}`;
      this.$timeout(() => {
        this.$anchorScroll(anchor);
      })
    } else {
      this.LogService.warn(`DashboardScreenController can't find first declined payroll period; not scrolling`);
    }
  }
}

export default DashboardScreenController;
